import { Kaggle } from "@kaggle/sdk";
import { getServices } from "../../../api/getServices";
import { getStore } from "../store/appStore";
import { AppAction } from "../types";
import { DefaultSessionSettingsActionKey as ActionKey } from "./ActionKeys";
type DefaultSessionSettings = Kaggle.Sdk.Kernels.DefaultSessionSettings;

export interface SetDefaultSessionSettingsAction
  extends AppAction<
    ActionKey.SET_DEFAULT_SESSION_SETTINGS,
    {
      settings: DefaultSessionSettings;
    }
  > {}

export type DefaultSessionSettingsActions = SetDefaultSessionSettingsAction;

const setDefaultSessionSettings = (
  settings: DefaultSessionSettings
): SetDefaultSessionSettingsAction =>
  getStore().dispatch({
    type: ActionKey.SET_DEFAULT_SESSION_SETTINGS,
    payload: { settings },
  });

export const updateDefaultSessionSettings = async (
  settings: DefaultSessionSettings
) => {
  const kernelId = getStore().getState().notebook.kernel;
  if (kernelId === null) {
    throw new Error("Cannot update user settings for null kernelId");
  }

  await getServices().kernelsClient.kernelsService.updateDefaultSessionSettings(
    {
      kernelId,
      settings,
    }
  );
  await fetchDefaultSessionSettings();
};

export const fetchDefaultSessionSettings = async () => {
  const kernelId = getStore().getState().notebook.kernel;
  if (kernelId === null) {
    throw new Error("Cannot fetch user settings for null kernelId");
  }

  const settings =
    await getServices().kernelsClient.kernelsService.getDefaultSessionSettings({
      kernelId,
    });
  setDefaultSessionSettings(settings);
};
